// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "zays span.letter {\n  padding-right: 5px;\n  cursor: pointer;\n}\nzays #search {\n  width: 200px;\n}\nzays #zays td:nth-of-type(4) {\n  max-width: 300px;\n  word-wrap: break-word;\n}\nzays #zays td:nth-of-type(5) {\n  max-width: 400px;\n  word-wrap: break-word;\n}\nzays #zays td:nth-of-type(6) {\n  width: 150px;\n}", ""]);
// Exports
module.exports = exports;
